module.exports = __webpack_public_path__ + "static/img/qixie.c36ed3f3.png";